import { createFileRoute } from "@tanstack/react-router";

import { vehicleSearchParamsSchema } from "@/domain/vehicle";
import { VehiclesScreen } from "@/interactors/VehiclesScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/vehicles/")({
  component: VehiclesScreen,
  beforeLoad: ({ context }) =>
    validateRoutePermission({ context, action: "list", subject: "vehicles" }),
  head: () => headWithCustomTitle("main:vehicles.title"),
  validateSearch: vehicleSearchParamsSchema,
});
